module.exports = __webpack_public_path__ + "a763fbfd89c8bd6778a9a71972b71ea5.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/RE.svg
// module id = HzG2
// module chunks = 0